























import { Vue, Component, Prop } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import * as images from "../../assets/images";
import { DocProgettoOrientamento } from "../../_models/docProgettoOrientamento";
import { bus } from "../../main";

//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component
export default class ProgettoOrientamentoTirEstivoReview extends Vue {
  @Prop() docInfo!: DocProgettoOrientamento;
  private ruoloUtente: number[];
  private tipoAttivita: string;

  private elements: DocProgettoOrientamento;

  private doc: any;

  constructor() {
    super();
    this.ruoloUtente = [];
    this.tipoAttivita = "";
    this.elements = {
      idProgettoOrientamento: this.docInfo.idProgettoOrientamento,
      denominazioneIstituto: this.docInfo.denominazioneIstituto,
      indirizzoIstituto: this.docInfo.indirizzoIstituto,
      capIstituto: this.docInfo.capIstituto,
      comuneIstituto: this.docInfo.comuneIstituto,
      provinciaIstituto: this.docInfo.provinciaIstituto,
      telefonoIstituto: this.docInfo.telefonoIstituto,
      emailIstituto: this.docInfo.emailIstituto,
      pecIstituto: this.docInfo.pecIstituto,
      codiceFiscaleIstituto: this.docInfo.codiceFiscaleIstituto,
      dirigenteIstituto: this.docInfo.dirigenteIstituto,
      luogoNascitaDirigenteIstituto: this.docInfo.luogoNascitaDirigenteIstituto,
      dataNascitaDirigenteIstituto: this.docInfo.dataNascitaDirigenteIstituto,
      tutorFormativo: this.docInfo.tutorFormativo,
      denominazioneAzienda: this.docInfo.denominazioneAzienda,
      indirizzoAzienda: this.docInfo.indirizzoAzienda,
      capAzienda: this.docInfo.capAzienda,
      comuneAzienda: this.docInfo.comuneAzienda,
      provinciaAzienda: this.docInfo.provinciaAzienda,
      telefonoAzienda: this.docInfo.telefonoAzienda,
      emailAzienda: this.docInfo.emailAzienda,
      pecAzienda: this.docInfo.pecAzienda,
      pIvaAzienda: this.docInfo.pIvaAzienda,
      indirizzoTirocinio: this.docInfo.indirizzoTirocinio,
      comuneTirocinio: this.docInfo.comuneTirocinio,
      provinciaTirocinio: this.docInfo.provinciaTirocinio,
      codAteco: this.docInfo.codAteco,
      descrizioneAteco: this.docInfo.descrizioneAteco,
      codIstat: this.docInfo.codIstat,
      descrizioneIstat: this.docInfo.descrizioneIstat,
      rappresentanteAzienda: this.docInfo.rappresentanteAzienda,
      luogoNascitaRappresentante: this.docInfo.luogoNascitaRappresentante,
      dataNascitaRappresentante: this.docInfo.dataNascitaRappresentante,
      tutorAziendale: this.docInfo.tutorAziendale,
      tirocinante: this.docInfo.tirocinante,
      dataNascitaTirocinante: this.docInfo.dataNascitaTirocinante,
      luogoNascitaTirocinante: this.docInfo.luogoNascitaTirocinante,
      indirizzoTirocinante: this.docInfo.indirizzoTirocinante,
      comuneTirocinante: this.docInfo.comuneTirocinante,
      provinciaTirocinante: this.docInfo.provinciaTirocinante,
      telefonoTirocinante: this.docInfo.telefonoTirocinante,
      emailTirocinante: this.docInfo.emailTirocinante,
      codiceFiscaleTirocinante: this.docInfo.codiceFiscaleTirocinante,
      classeTirocinante: this.docInfo.classeTirocinante,
      durataTirocinio: this.docInfo.durataTirocinio,
      dataInizioPeriodo: this.docInfo.dataInizioPeriodo,
      dataFinePeriodo: this.docInfo.dataFinePeriodo,
      orarioInizioMattino: this.docInfo.orarioInizioMattino,
      orarioFineMattino: this.docInfo.orarioFineMattino,
      orarioInizioPomeriggio: this.docInfo.orarioInizioPomeriggio,
      orarioFinePomeriggio: this.docInfo.orarioFinePomeriggio,
      usoFuoriSede: this.docInfo.usoFuoriSede,
      posizioneINAIL: this.docInfo.posizioneINAIL,
      numeroPolizzaAssicurativa: this.docInfo.numeroPolizzaAssicurativa,
      assicurazione: this.docInfo.assicurazione,
      facilitazione: this.docInfo.facilitazione,
      attivitaTirocinio: this.docInfo.attivitaTirocinio,
      dataDocumento: this.docInfo.dataDocumento,
      idStatoDoc: this.docInfo.idStatoDoc,
      firmaAzienda: this.docInfo.firmaAzienda,
      firmaTirocinante: this.docInfo.firmaTirocinante,
      firmaAziendaDue: this.docInfo.firmaAziendaDue,
      firmaTirocinanteDue: this.docInfo.firmaTirocinanteDue,
      firmaEsercentePatriaPotesta: this.docInfo.firmaEsercentePatriaPotesta,
      firmaIstituto: this.docInfo.firmaIstituto,
      capTirocinio: this.docInfo.capTirocinio,
      tipoAttivita: this.docInfo.tipoAttivita,
      numeroProtocollo: this.docInfo.numeroProtocollo,
      idTemplate: this.docInfo.idTemplate
    };
    this.doc = null;
  }

  createDoc() {
    if (this.elements.firmaAzienda === null) {
      this.elements.firmaAzienda = images.noFirma;
    }
    if (this.elements.firmaAziendaDue === null) {
      this.elements.firmaAziendaDue = images.noFirma;
    }
    if (this.elements.firmaTirocinante === null) {
      this.elements.firmaTirocinante = images.noFirma;
    }
    if (this.elements.firmaTirocinanteDue === null) {
      this.elements.firmaTirocinanteDue = images.noFirma;
    }

    var dd = {
      /**--------------------------------------------------------
         * Le immagini di header e footer sono convertite in Base64
         * ed importate dal file Header_Footer.js
         ----------------------------------------------------------*/
      pageSize: "A4",
      // ****** FOOTER *********//
      footer: function(/*currentPage, pageCount*/) {
        return [
          {
            image: images.authFooter,
            width: "560",
            height: "80",
            margin: [20, 0]
          }
        ];
      },
      // ******** HEADER ******** //
      header: function(/*currentPage, pageCount, pageSize*/) {
        // you can apply any logic and return any valid pdfmake element

        return [
          {
            // image: images.authHeader,
            image: images.authHeader,
            width: "525",
            height: "90",
            margin: [35, 0]
          }
        ];
      },

      //******** TESTO DEL DOCUMENTO  ********/
      content: [
        {
          text: "PROGETTO DI ORIENTAMENTO",
          alignment: "center",
          margin: [0, 70, 0, 5],
          bold: true,
          fontSize: 18
        },
        {
          text: "ai sensi della DGR n. 19-4575 del 16 gennaio 2017",
          alignment: "center",
          fontSize: 16,
          margin: [0, 0, 0, 10]
        },
        {
          text:
            "Convenzione stipulata in data " +
            this.elements.dataDocumento +
            " con protocollo n. " +
            this.elements.numeroProtocollo,
          style: "bodyText"
        },
        {
          text: "Soggetto Promotore",
          style: "bodyText",
          margin: [0, 10, 0, 10],
          bold: true
        },
        {
          table: {
            widths: [200, "*"],
            body: [
              [
                { text: "Denominazione Istituto", style: "tableTitle" },
                {
                  text: this.elements.denominazioneIstituto,
                  style: "tableText"
                }
              ],
              [
                { text: "Indirizzo", style: "tableTitle" },
                { text: this.elements.indirizzoIstituto, style: "tableText" }
              ],
              [
                { text: "CAP Comune Provincia", style: "tableTitle" },
                {
                  text:
                    this.elements.comuneIstituto +
                    " " +
                    this.elements.provinciaIstituto +
                    " " +
                    this.elements.capIstituto,
                  style: "tableText"
                }
              ],
              [
                { text: "Telefono", style: "tableTitle" },
                { text: this.elements.telefonoIstituto, style: "tableText" }
              ],
              [
                { text: "Indirizzo e-mail", style: "tableTitle" },
                { text: "pcto@vallauri.edu", style: "tableText" }
              ],
              [
                { text: "PEC", style: "tableTitle" },
                { text: "CNISO1700C@PEC.ISTRUZIONE.IT", style: "tableText" }
              ],
              [
                { text: "Codice Fiscale/Partita IVA", style: "tableTitle" },
                {
                  text: this.elements.codiceFiscaleIstituto,
                  style: "tableText"
                }
              ],
              [
                {
                  text: "Dirigente Scolastico/Legale Rappresentante",
                  style: "tableTitle"
                },
                { text: this.elements.dirigenteIstituto, style: "tableText" }
              ],
              [
                { text: "Nato/a a", style: "tableTitle" },
                {
                  text: this.elements.luogoNascitaDirigenteIstituto,
                  style: "tableText"
                }
              ],
              [
                { text: "Nato/a il", style: "tableTitle" },
                {
                  text: this.elements.dataNascitaDirigenteIstituto,
                  style: "tableText"
                }
              ],
              [
                { text: "Nominativo Tutor Scolastico", style: "tableTitle" },
                { text: this.elements.tutorFormativo, style: "tableText" }
              ]
            ]
          }
        },
        {
          text: "Soggetto Ospitante",
          style: "bodyText",
          margin: [0, 10, 0, 10],
          bold: true
        },
        {
          table: {
            widths: [200, "*"],
            body: [
              [
                { text: "Denominazione Azienda", style: "tableTitle" },
                { text: this.elements.denominazioneAzienda, style: "tableText" }
              ],
              [
                { text: "Indirizzo", style: "tableTitle" },
                { text: this.elements.indirizzoAzienda, style: "tableText" }
              ],
              [
                { text: "CAP Comune Provincia", style: "tableTitle" },
                {
                  text:
                    this.elements.comuneAzienda +
                    " " +
                    this.elements.provinciaAzienda +
                    " " +
                    this.elements.capAzienda,
                  style: "tableText"
                }
              ],
              [
                { text: "Telefono", style: "tableTitle" },
                { text: this.elements.telefonoAzienda, style: "tableText" }
              ],
              [
                { text: "Indirizzo e-mail", style: "tableTitle" },
                { text: this.elements.emailAzienda, style: "tableText" }
              ],
              [
                { text: "PEC", style: "tableTitle" },
                { text: this.elements.pecAzienda, style: "tableText" }
              ],
              [
                { text: "Indirizzo sede Tirocinio", style: "tableTitle" },
                { text: this.elements.indirizzoTirocinio, style: "tableText" }
              ],
              [
                { text: "CAP Comune Provincia Tirocinio", style: "tableTitle" },
                {
                  text:
                    this.elements.comuneTirocinio +
                    " " +
                    this.elements.provinciaTirocinio +
                    " " +
                    this.elements.capTirocinio,
                  style: "tableText"
                }
              ],
              [
                {
                  text: "Settore aziendale di inserimento",
                  style: "tableTitle"
                },
                {
                  text:
                    this.elements.codAteco +
                    " - " +
                    this.elements.descrizioneAteco,
                  style: "tableText"
                }
              ],
              [
                {
                  text:
                    "Area professionale di riferimento dell'attività del tirocinio",
                  style: "tableTitle"
                },
                {
                  text:
                    this.elements.codIstat +
                    " " +
                    this.elements.descrizioneIstat,
                  style: "tableText"
                }
              ],
              [
                { text: "Codice Fiscale/Partita IVA", style: "tableTitle" },
                { text: this.elements.pIvaAzienda, style: "tableText" }
              ],
              [
                { text: "Legale Rappresentante", style: "tableTitle" },
                {
                  text: this.elements.rappresentanteAzienda,
                  style: "tableText"
                }
              ],
              [
                { text: "Nato/a a", style: "tableTitle" },
                {
                  text: this.elements.luogoNascitaRappresentante,
                  style: "tableText"
                }
              ],
              [
                { text: "Nato/a il", style: "tableTitle" },
                {
                  text: this.elements.dataNascitaRappresentante,
                  style: "tableText"
                }
              ],
              [
                { text: "Nominativo Tutor Aziendale", style: "tableTitle" },
                { text: this.elements.tutorAziendale, style: "tableText" }
              ]
            ]
          },
          pageBreak: "after"
        },
        {
          text: "Tirocinante",
          style: "bodyText",
          margin: [0, 70, 0, 10],
          bold: true
        },
        {
          table: {
            widths: [200, "*"],
            body: [
              [
                { text: "Cognome Nome", style: "tableTitle" },
                { text: this.elements.tirocinante, style: "tableText" }
              ],
              [
                { text: "Nato/a a", style: "tableTitle" },
                {
                  text: this.elements.luogoNascitaTirocinante,
                  style: "tableText"
                }
              ],
              [
                { text: "Nato/a il", style: "tableTitle" },
                {
                  text: this.elements.dataNascitaTirocinante,
                  style: "tableText"
                }
              ],
              [
                { text: "Indirizzo", style: "tableTitle" },
                { text: this.elements.indirizzoTirocinante, style: "tableText" }
              ],
              [
                { text: "Cap Comune Provincia", style: "tableTitle" },
                {
                  text:
                    this.elements.comuneTirocinante +
                    " " +
                    this.elements.provinciaTirocinante,
                  style: "tableText"
                }
              ],
              [
                { text: "Telefono", style: "tableTitle" },
                { text: this.elements.telefonoTirocinante, style: "tableText" }
              ],
              [
                { text: "Codice Fiscale", style: "tableTitle" },
                {
                  text: this.elements.codiceFiscaleTirocinante,
                  style: "tableText"
                }
              ],
              [
                {
                  text:
                    "Classe frequentata dallo studente di Istituto Scolastico Secondario di Secondo Grado",
                  style: "tableTitle"
                },
                { text: this.elements.classeTirocinante, style: "tableText" }
              ]
            ]
          }
        },
        {
          text: "Dati generali tirocinio",
          style: "bodyText",
          margin: [0, 10, 0, 10],
          bold: true
        },
        {
          table: {
            widths: [200, "*"],
            body: [
              [
                {
                  text: "Durata del tirocinio (max 3 mesi)",
                  style: "tableTitle"
                },
                {
                  text: "compreso tra il 20/06/2020 ed il 31/08/2020",
                  style: "tableText"
                }
              ],
              [
                {
                  text: "Periodo: data inizio - data fine",
                  style: "tableTitle"
                },
                {
                  text:
                    this.elements.dataInizioPeriodo +
                    " - " +
                    this.elements.dataFinePeriodo,
                  style: "tableText"
                }
              ],
              [
                {
                  text: "Impegno orario settimanale presso l'azienda",
                  style: "tableTitle"
                },
                { text: "max 40 ore", style: "tableText" }
              ],
              [
                {
                  text: "Orario: mattutino / pomeridiano",
                  style: "tableTitle"
                },
                {
                  text:
                    this.elements.orarioInizioMattino +
                    " - " +
                    this.elements.orarioFineMattino +
                    " / " +
                    this.elements.orarioInizioPomeriggio +
                    " - " +
                    this.elements.orarioFinePomeriggio,
                  style: "tableText"
                }
              ],
              [
                {
                  text: "Utilizzo anche in attività fuori sede",
                  style: "tableTitle"
                },
                { text: this.elements.usoFuoriSede, style: "tableText" }
              ],
              [
                { text: "Posizione INAIL", style: "tableTitle" },
                {
                  text:
                    "INAIL: gestita per conto dello Stato (Legge 1124/65, DPR 9.04.1999 n.156 art. 2)",
                  style: "tableText"
                }
              ],
              [
                {
                  text: "Responsabilità Civile posizione n.",
                  style: "tableTitle"
                },
                {
                  text: this.elements.numeroPolizzaAssicurativa,
                  style: "tableText"
                }
              ],
              [
                { text: "Compagnia di Assicurazione", style: "tableTitle" },
                { text: this.elements.assicurazione, style: "tableText" }
              ],
              [
                {
                  text:
                    "Facilitazione eventualmente previste (buoni pasto, mensa, trasporti ecc.)",
                  style: "tableTitle"
                },
                { text: this.elements.facilitazione, style: "tableText" }
              ]
            ]
          }
        },
        {
          text: "Obiettivi del tirocinio",
          style: "bodyText",
          margin: [0, 10, 0, 10],
          bold: true
        },
        {
          table: {
            widths: [100, "*"],
            body: [
              [
                { text: "Micro obiettivi", style: "tableTitle" },
                { text: this.elements.attivitaTirocinio, style: "tableText" }
              ],
              [
                { text: "Macro obiettivi", style: "tableTitle" },
                {
                  text:
                    "Presa di contatto con le problematiche della realtà operativa con una esperienza conoscitiva diretta dell'ambiente, delle relazioni, della struttura dell'azienda. Conoscenza diretta dell'ambiente lavorativo con i relativi orari, impegni, metodi e tempi di lavoro sostanzialmente diversi da quelli scolastici. Ampliamento e perfezionamento delle conoscenze e delle abilità acquisite frequentando le lezioni curricolari, attraverso la loro applicazione in azienda e mediante l'utilizzo di nuove attrezzature.",
                  style: "tableText"
                }
              ]
            ]
          }
        },
        {
          text: "Modalità di svolgimento",
          style: "bodyText",
          margin: [0, 10, 0, 10],
          bold: true
        },
        {
          ul: [
            {
              text:
                "il tirocinante si adeguerà agli orari, al ritmo e alla vita aziendale degli altri colleghi di lavoro per conoscere gli aspetti umani, sociali, organizzativi e sindacali dell’azienda.",
              style: "bodyText"
            },
            {
              text:
                "il tirocinante sarà inizialmente affiancato ad altri operatori di reparto e gradualmente guidato verso una autonomia operativa compatibile con le sue capacità.",
              style: "bodyText"
            },
            {
              text:
                "il tirocinante, nei limiti delle possibilità aziendali, verrà fatto ruotare in due o più posti di lavoro per una maggior articolazione dell'esperienza lavorativa e per avere una piena consapevolezza delle attività aziendali. Verrà, inoltre, organizzata la sua attività, almeno parzialmente, con modalità di smart working a distanza.",
              style: "bodyText"
            }
          ],
          pageBreak: "after"
        },
        {
          text: "Figura professionale",
          style: "bodyText",
          margin: [0, 70, 0, 10],
          bold: true
        },
        {
          text:
            "Corrispondente all’area di riferimento dell’attività di tirocinio di cui alla tabella “Soggetto Ospitante”, cfr. :",
          style: "bodyText",
          margin: [0, 5, 0, 0]
        },
        {
          ul: [
            {
              text: "Repertorio Nazionale L.g. n. 92/2012, art. 4, comma 67;",
              style: "bodyText"
            },
            {
              text: "http://cp2011.istat.it ;",
              style: "bodyText"
            },
            {
              text:
                "http://www.collegamenti.org/vetrinaregione/vetrinaregione.asp ;",
              style: "bodyText"
            }
          ]
        },
        {
          text: "Il tirocinante è tenuto a:",
          style: "bodyText",
          bold: true,
          margin: [0, 10, 0, 10]
        },
        {
          ul: [
            {
              text:
                "svolgere le attività previste dal Progetto di Orientamento, osservando gli orari concordati e i regolamenti aziendali;",
              style: "bodyText"
            },
            {
              text:
                "seguire le indicazioni dei tutor e fare riferimento ad essi per qualsiasi esigenza di tipo organizzativo o altre evenienze;",
              style: "bodyText"
            },
            {
              text:
                "rispettare le disposizioni di cui all’art. 20 del Decreto Legislativo n. 81/2008 (“Testo Unico in materia di tutela della salute e sicurezza sui luoghi di lavoro”);",
              style: "bodyText"
            },
            {
              text:
                "mantenere la necessaria riservatezza per quanto attiene a dati, informazioni o conoscenze in merito a processi produttivi e prodotti, sia durante che dopo lo svolgimento del tirocinio.",
              style: "bodyText"
            },
            {
              text:
                "redigere, al termine dello stage, una relazione scritta sulle attività svolte con una valutazione personale dell'esperienza.",
              style: "bodyText"
            }
          ]
        },
        {
          text:
            "Il tirocinante ha diritto ad ottenere il rilascio da parte del soggetto promotore dell’attestazione della valutazione delle attività svolte e delle competenze acquisite.",
          style: "bodyText",
          margin: [0, 10, 0, 0]
        },
        {
          text:
            "Ha inoltre diritto, qualora siano presenti presso le strutture del Soggetto Ospitante, alle facilitazioni in uso (buoni pasto, accesso alla mensa, trasporti, etc.)",
          style: "bodyText",
          pageBreak: "after"
        },
        {
          text:
            "Pur non essendo prevista per legge alcuna retribuzione economica, il Soggetto Ospitante ha facoltà di riconoscere al tirocinante un compenso a titolo di borsa di studio. 200 euro",
          style: "bodyText",
          margin: [0, 70, 0, 0]
        },
        {
          text: "Fossano, " + this.elements.dataDocumento,
          style: "bodyText",
          margin: [0, 20, 0, 0]
        },
        {
          text: "Firma SOGGETTO PROMOTORE",
          style: "bodyText",
          alignment: "right"
        },
        {
          text: "Il Dirigente Scolastico",
          style: "bodyText",
          alignment: "right"
        },
        {
          text: this.elements.dirigenteIstituto,
          style: "bodyText",
          bold: "true",
          alignment: "right"
        },
        {
          image: images.firmaVallauri,
          width: 200,
          alignment: "right"
        },
        {
          text: "Firma SOGGETTO OSPITANTE",
          style: "bodyText",
          alignment: "right",
          margin: [0, 30, 0, 0]
        },
        {
          text: "Legale Rappresentante",
          style: "bodyText",
          alignment: "right"
        },
        {
          text: this.elements.rappresentanteAzienda,
          style: "bodyText",
          bold: "true",
          alignment: "right"
        },
        {
          image: this.elements.firmaAzienda,
          width: 200,
          alignment: "right"
        },
        {
          text: "Firma per presa visione ed accettazione TIROCINANTE",
          style: "bodyText",
          alignment: "right",
          margin: [0, 70, 0, 0]
        },
        {
          text: this.elements.tirocinante,
          style: "bodyText",
          bold: "true",
          alignment: "right"
        },
        {
          image: this.elements.firmaTirocinante,
          width: 200,
          alignment: "right"
        },
        {
          text:
            "Ricevuta l’informativa di cui al D.lgs. n° 196/2003 ed a conoscenza dei diritti spettanti ai sensi dell’art.13 della Legge medesima, i sottoscritti consentono il trattamento dei dati sopra riportati da parte dell’ I.I.S “G. VALLAURI”” di Fossano per i suoi scopi istituzionali e per tutti gli effetti previsti dalla vigente normativa ed in particolare la loro eventuale comunicazione e/o diffusione secondo quanto previsto dall’art.20 della citata Legge nell’ambito delle finalità per cui i dati in questione sono stati raccolti.",
          style: "bodyTextSmall",
          margin: [0, 70, 0, 0],
          pageBreak: "after"
        },
        {
          text: "DICHIARAZIONE DI CONSENSO",
          alignment: "center",
          margin: [0, 70, 0, 0],
          bold: true,
          fontSize: 10
        },
        {
          text: "all'attivazione di un tirocinio estivo",
          alignment: "center",
          bold: true,
          fontSize: 10
        },
        {
          text: "ai sensi del DPGR Piemonte del 22/05/2020, art. 27",
          alignment: "center",
          bold: true,
          margin: [0, 0, 0, 10],
          fontSize: 10
        },
        {
          text: "I sottoscritti:",
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          ul: [
            {
              text:
                "Paolo CORTESE in qualità di Dirigente Scolastico dell’I.I.S. “g. VALLAURI” , codice fiscale 83003390040 con sede in Fossano, Via San Michele 68 - soggetto PROMOTORE,",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                this.elements.rappresentanteAzienda +
                " in qualità di legale rappresentante dell’azienda " +
                this.elements.denominazioneAzienda +
                ", P. IVA " +
                this.elements.pIvaAzienda +
                " con sede in " +
                this.elements.comuneAzienda +
                ", " +
                this.elements.indirizzoAzienda +
                " - soggetto OSPITANTE,",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                this.elements.tirocinante +
                " in qualità di tirocinante residente in " +
                this.elements.indirizzoTirocinante +
                ", " +
                this.elements.comuneTirocinante +
                " - TIROCINANTE",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            }
          ]
        },
        {
          text:
            "dichiarano il proprio consenso alla realizzazione di un tirocinio extracurriculare estivo, ai sensi delle normative regionale.",
          bold: true,
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          text: "L’inizio dell’attività di tirocinio è subordinata:",
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          ul: [
            {
              text:
                "al consenso di tutti gli interessati (TIROCINANTE / SOGGETTO PROMOTORE / SOGGETTO OSPITANTE), raccolto dal soggetto promotore (IIS “G. Vallauri”).",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            },
            {
              text:
                "alla messa in atto e all’osservanza, da parte del soggetto ospitante, di tutte le disposizioni relative alle misure organizzative di prevenzione e di protezione citate nei decreti normativi.",
              style: "bodyText",
              margin: [0, 0, 0, 5]
            }
          ]
        },
        {
          text:
            "Attraverso la sottoscrizione del presente consenso il SOGGETTO OSPITANTE dichiara di aver provveduto a metter in atto TUTTE le disposizioni relative alle misure organizzative di prevenzione e di protezione citate nei decreti normativi prima dell’INIZIO del tirocinio.",
          style: "bodyText",
          margin: [0, 0, 0, 5]
        },
        {
          text: "Fossano, " + this.elements.dataDocumento,
          style: "bodyText",
          margin: [0, 0, 0, 10]
        },
        {
          text: "IL SOGGETTO PROMOTORE",
          style: "bodyText",
          alignment: "right",
          margin: [0, 0, 0, 10]
        },
        {
          image: images.firmaVallauri,
          width: 200,
          alignment: "right"
        },
        {
          text: "IL SOGGETTO OSPITANTE",
          style: "bodyText",
          alignment: "right",
          margin: [0, 10, 0, 10]
        },
        {
          image: this.elements.firmaAziendaDue,
          width: 200,
          alignment: "right"
        },
        {
          text: "IL TIROCINANTE",
          style: "bodyText",
          alignment: "right",
          margin: [0, 10, 0, 10]
        },
        {
          image: this.elements.firmaTirocinanteDue,
          width: 200,
          alignment: "right"
        }
      ],
      styles: {
        bodyText: {
          fontSize: 10,
          justified: true
        },
        bodyTextSmall: {
          fontSize: 8,
          justified: true
        },
        tableTitle: {
          fontSize: 10,
          bold: "true",
          alignment: "right"
        },
        tableText: {
          fontSize: 8
        },
        tableTextHigh: {
          fontSize: 8,
          background: "yellow"
        }
      }
    };
    var finalDocStr: string = this.completeDoc();
    var json = JSON.parse(finalDocStr);

    const pdfDocGenerator = pdfMake.createPdf(json);
    // const pdfDocGenerator = pdfMake.createPdf(dd);
    pdfDocGenerator.getDataUrl(function(dataUrl: any) {
      const targetElement = document.querySelector("#iframeContainer");
      const embed = document.createElement("embed");
      embed.src = dataUrl;
      embed.width = "1000";
      embed.height = "700";
      if (targetElement !== null) {
        targetElement.appendChild(embed);
      }
    });
  }

  completeDoc(): string {
    var completeDoc: string = "";
    completeDoc = JSON.stringify(this.doc);
    // var finalStr = this.docTest.replace(/%%_tirocinante_%%/g, '"' + this.elements.tirocinante + '"')
    completeDoc = completeDoc.replace(/%%_header_%%/g, images.authHeader);
    completeDoc = completeDoc.replace(/%%_footer_%%/g, images.authFooter);
    completeDoc = completeDoc.replace(/%%_headerDocVallauri_%%/g, images.headerDocVallauri);
    completeDoc = completeDoc.replace(/%%_footerDocVallauri_%%/g, images.footerDocVallauri);
    completeDoc = completeDoc.replace(
      /%%_denominazioneIstituto_%%/g,
      this.elements.denominazioneIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoIstituto_%%/g,
      this.elements.indirizzoIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_capIstituto_%%/g,
      this.elements.capIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_comuneIstituto_%%/g,
      this.elements.comuneIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaIstituto_%%/g,
      this.elements.provinciaIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_telefonoIstituto_%%/g,
      this.elements.telefonoIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_emailIstituto_%%/g,
      this.elements.emailIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_codiceFiscaleIstituto_%%/g,
      this.elements.codiceFiscaleIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_dirigenteIstituto_%%/g,
      this.elements.dirigenteIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_luogoNascitaDirigenteIstituto_%%/g,
      this.elements.luogoNascitaDirigenteIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_dataNascitaDirigenteIstituto_%%/g,
      this.elements.dataNascitaDirigenteIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_tutorFormativo_%%/g,
      this.elements.tutorFormativo
    );
    completeDoc = completeDoc.replace(
      /%%_denominazioneAzienda_%%/g,
      this.elements.denominazioneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoAzienda_%%/g,
      this.elements.indirizzoAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_capAzienda_%%/g,
      this.elements.capAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_comuneAzienda_%%/g,
      this.elements.comuneAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaAzienda_%%/g,
      this.elements.provinciaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_telefonoAzienda_%%/g,
      this.elements.telefonoAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_emailAzienda_%%/g,
      this.elements.emailAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_pecAzienda_%%/g,
      this.elements.pecAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_pIvaAzienda_%%/g,
      this.elements.pIvaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoTirocinio_%%/g,
      this.elements.indirizzoTirocinio
    );
    completeDoc = completeDoc.replace(
      /%%_comuneTirocinio_%%/g,
      this.elements.comuneTirocinio
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaTirocinio_%%/g,
      this.elements.provinciaTirocinio
    );
    completeDoc = completeDoc.replace(
      /%%_codAteco_%%/g,
      this.elements.codAteco
    );
    completeDoc = completeDoc.replace(
      /%%_descrizioneAteco_%%/g,
      this.elements.descrizioneAteco
    );
    completeDoc = completeDoc.replace(
      /%%_codIstat_%%/g,
      this.elements.codIstat
    );
    completeDoc = completeDoc.replace(
      /%%_descrizioneIstat_%%/g,
      this.elements.descrizioneIstat
    );
    completeDoc = completeDoc.replace(
      /%%_rappresentanteAzienda_%%/g,
      this.elements.rappresentanteAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_luogoNascitaRappresentante_%%/g,
      this.elements.luogoNascitaRappresentante
    );
    completeDoc = completeDoc.replace(
      /%%_dataNascitaRappresentante_%%/g,
      this.elements.dataNascitaRappresentante
    );
    completeDoc = completeDoc.replace(
      /%%_tutorAziendale_%%/g,
      this.elements.tutorAziendale
    );
    completeDoc = completeDoc.replace(
      /%%_tirocinante_%%/g,
      this.elements.tirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_dataNascitaTirocinante_%%/g,
      this.elements.dataNascitaTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_luogoNascitaTirocinante_%%/g,
      this.elements.luogoNascitaTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_indirizzoTirocinante_%%/g,
      this.elements.indirizzoTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_comuneTirocinante_%%/g,
      this.elements.comuneTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_provinciaTirocinante_%%/g,
      this.elements.provinciaTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_telefonoTirocinante_%%/g,
      this.elements.telefonoTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_emailTirocinante_%%/g,
      this.elements.emailTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_codiceFiscaleTirocinante_%%/g,
      this.elements.codiceFiscaleTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_classeTirocinante_%%/g,
      this.elements.classeTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_durataTirocinio_%%/g,
      this.elements.durataTirocinio
    );
    completeDoc = completeDoc.replace(
      /%%_dataInizioPeriodo_%%/g,
      this.elements.dataInizioPeriodo
    );
    completeDoc = completeDoc.replace(
      /%%_dataFinePeriodo_%%/g,
      this.elements.dataFinePeriodo
    );
    completeDoc = completeDoc.replace(
      /%%_orarioInizioMattino_%%/g,
      this.elements.orarioInizioMattino
    );
    completeDoc = completeDoc.replace(
      /%%_orarioFineMattino_%%/g,
      this.elements.orarioFineMattino
    );
    completeDoc = completeDoc.replace(
      /%%_orarioInizioPomeriggio_%%/g,
      this.elements.orarioInizioPomeriggio
    );
    completeDoc = completeDoc.replace(
      /%%_orarioFinePomeriggio_%%/g,
      this.elements.orarioFinePomeriggio
    );
    completeDoc = completeDoc.replace(
      /%%_usoFuoriSede_%%/g,
      this.elements.usoFuoriSede
    );
    completeDoc = completeDoc.replace(
      /%%_posizioneINAIL_%%/g,
      this.elements.posizioneINAIL
    );
    completeDoc = completeDoc.replace(
      /%%_numeroPolizzaAssicurativa_%%/g,
      this.elements.numeroPolizzaAssicurativa
    );
    completeDoc = completeDoc.replace(
      /%%_assicurazione_%%/g,
      this.elements.assicurazione
    );
    completeDoc = completeDoc.replace(
      /%%_facilitazione_%%/g,
      this.elements.facilitazione
    );
    completeDoc = completeDoc.replace(
      /%%_attivitaTirocinio_%%/g,
      this.elements.attivitaTirocinio
    );
    completeDoc = completeDoc.replace(
      /%%_dataDocumento_%%/g,
      this.elements.dataDocumento
    );
    completeDoc = completeDoc.replace(
      /%%_firmaAzienda_%%/g,
      this.elements.firmaAzienda
    );
    completeDoc = completeDoc.replace(
      /%%_firmaTirocinante_%%/g,
      this.elements.firmaTirocinante
    );
    completeDoc = completeDoc.replace(
      /%%_firmaAziendaDue_%%/g,
      this.elements.firmaAziendaDue
    );
    completeDoc = completeDoc.replace(
      /%%_firmaTirocinanteDue_%%/g,
      this.elements.firmaTirocinanteDue
    );
    completeDoc = completeDoc.replace(
      /%%_firmaEsercentePatriaPotesta_%%/g,
      this.elements.firmaEsercentePatriaPotesta
    );
    completeDoc = completeDoc.replace(
      /%%_firmaIstituto_%%/g,
      this.elements.firmaIstituto
    );
    completeDoc = completeDoc.replace(
      /%%_capTirocinio_%%/g,
      this.elements.capTirocinio
    );
    completeDoc = completeDoc.replace(
      /%%_tipoAttivita_%%/g,
      this.elements.tipoAttivita
    );
    completeDoc = completeDoc.replace(
      /%%_numeroProtocollo_%%/g,
      this.elements.numeroProtocollo
    );

    return completeDoc;
  }

  confirm() {
    var payload = {
      idProgettoOrientamento: this.elements.idProgettoOrientamento
    };
    if (
      this.elements.firmaAzienda !== null &&
      this.elements.firmaTirocinante !== null &&
      this.elements.firmaAziendaDue !== null &&
      this.elements.firmaTirocinanteDue !== null
    ) {
      user
        .dispatchConfirmProgettoOrientamento(this["$store"], payload)
        .then(() => {
          this.close();
          bus.$emit("loadPreAssegnazioni");
          bus.$emit(
            "successfullOperation",
            "Progetto Orientamento accettato con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else {
      bus.$emit(
        "errorOperation",
        "Impossibile accettare documento. Firma Azienda e/o Firma Tirocinante mancante"
      );
    }
  }
  refuse() {
    var payload = {
      idProgettoOrientamento: this.elements.idProgettoOrientamento
    };
    if (
      this.elements.firmaAzienda !== null &&
      this.elements.firmaTirocinante !== null &&
      this.elements.firmaAziendaDue !== null &&
      this.elements.firmaTirocinanteDue !== null
    ) {
      user
        .dispatchRefuseProgettoOrientamento(this["$store"], payload)
        .then(() => {
          this.close();
          bus.$emit("loadPreAssegnazioni");
          bus.$emit(
            "successfullOperation",
            "Progetto Orientamento rifiutato con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else {
      bus.$emit(
        "errorOperation",
        "Impossibile accettare documento. Firma Azienda e/o Firma Tirocinante mancante"
      );
    }
  }

  close() {
    bus.$emit("closeReview");
  }

  created() {
    // var userInfo = user.readUserInfo(this["$store"]);
    // if (userInfo === null) {
    //   userInfo = user.readStudentInfo(this["$store"]);
    // }
    // this.ruoloUtente = userInfo.ruoloUtente;
    // this.createDoc();

    data
      .dispatchTemplateDoc(this["$store"], this.docInfo.idTemplate)
      .then(result => {
        this.doc = result;
        if (this.docInfo.tipoAttivita === "tirocinioReIns") {
          this.tipoAttivita = "tirocinio di inserimento/reinserimento";
        } else if (this.docInfo.tipoAttivita === "tirocinioFormativo") {
          this.tipoAttivita = "tirocinio formativo e di orientamento";
        }
        var userInfo = user.readUserInfo(this["$store"]);
        if (userInfo === null) {
          userInfo = user.readStudentInfo(this["$store"]);
        }
        this.ruoloUtente = userInfo.ruoloUtente;
        this.createDoc();
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }
}
